<template>
  <div
    class="control_background"
    :class="backgroundState === '1' || backgroundState === null ? 'control_background_seytem' : ''"
  >
    <div v-if="backgroundState === '2'" class="currency_background_vue_dongxiao">
      <!-- 星空动效背景 2-->
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
    </div>

    <div class="control-background-softener" :style="{ backgroundColor: softenerColor }"></div>
    <main-top-nav v-if="!isFollowEditor && !isModernRegion"></main-top-nav>
    <div
      class="control_page"
      :class="{ 'follow-editor': isFollowEditor, 'embedded-region-page': isModernRegion }"
    >
      <!-- 被keep-alive包含的所有路径都会被缓存，组件不会被反复的销毁和创建。
        这时候对应的activated钩子函数有效，组件被激活进入 -->
      <keep-alive>
        <router-view v-if="!isFollowEditor"></router-view>
      </keep-alive>
      <router-view v-if="isFollowEditor"></router-view>

      <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    </div>
    <main-tab-bar v-if="!isFollowEditor"></main-tab-bar>
    <ai-entry v-if="!isFollowEditor" />
  </div>
</template>

<script>
import AiEntry from '@/components/content/ai/AiEntry.vue'
import { getServerApiLevelState } from '@/common/compatibility/server-api-level'
import { getControlBackgroundSoftenerColor } from '@/common/control-background'
import MainTabBar from 'components/content/maintabbar/MainTabBar'
import MainTopNav from 'components/content/miantopnav/MaintopNav'
export default {
  name: 'ControlPage',
  data() {
    return {
      backgroundState: sessionStorage.getItem('backgroundSelectState')
    }
  },
  components: {
    AiEntry,
    MainTabBar,
    MainTopNav
  },
  computed: {
    isModernRegion() {
      return /\/region$/i.test(this.$route.path) && getServerApiLevelState(this).useModernRegion
    },
    isFollowEditor() {
      return /homechangedevice|homechangescene/i.test(this.$route.path)
    },
    softenerColor() {
      return getControlBackgroundSoftenerColor(this.$store.state.userinfo.backgroundSofteningLevel)
    }
  },
  deactivated() { this.setNavigationGuard(false) },
  beforeDestroy() { this.setNavigationGuard(false) },
  activated() {
    this.setNavigationGuard(true)
    this.backgroundState = sessionStorage.getItem('backgroundSelectState') || '1'
  },
  methods: {
    setNavigationGuard(enabled) {
      document.documentElement.classList.toggle('control-navigation', enabled)
      document.body.classList.toggle('control-navigation', enabled)
    },
    backgroundSelectState() {
      //背景的选择状态
      if (localStorage.getItem('backgroundSelectState') === null) {
        console.log('用户还没有设置背景')
        localStorage.setItem('backgroundSelectState', '1')
      }
      ////把本地缓存拿到浏览器缓存，方便调用
      sessionStorage.setItem('backgroundSelectState', localStorage.getItem('backgroundSelectState'))
    }
  },
  mounted() {
    this.setNavigationGuard(true)
    this.$nextTick(() => {
      //正确写法
      this.backgroundSelectState() ///背景状态的初始化和判断
      this.backgroundState = sessionStorage.getItem('backgroundSelectState') || '1'
      console.log(sessionStorage.getItem('backgroundSelectState'))
    })
  }
}
</script>

<style>
.control_page {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto; /* 屏幕居中，上下0px  左右自动居中 */
  border-radius: 5px;
  /* box-shadow: 0 0 1px var(--primary-color); */
  box-sizing: border-box;
  padding-top: 0px;
  padding-left: 10px;
  padding-right: 10px;

  /* background: url('../../../assets/img/background/background1.png');
    background-size: 100% auto;  */
  /* 火狐浏览器滚动条隐藏 */
  overflow: auto;
  overflow-y: scroll;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
}
/* Chrome 和 Safari滚动条隐藏 */
.control_page::-webkit-scrollbar {
  display: none;
}
</style>

<style>
.control_background {
  isolation: isolate;
}
.control-background-softener {
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
}
.control_page {
  position: relative;
  min-height: 0;
}
.control_page:has(.modern-region) {
  overflow: hidden;
}
</style>
<style>
.control_page {
  height: calc(100% - 120px);
}
.control_page.follow-editor {
  height: 100%;
  overflow: hidden;
}
.candidate-heading {
  color: white;
}
.candidate-heading .control-link {
  font-size: 16px;
  line-height: 24px;
  min-height: 44px;
}
.candidate-heading .control-link,
.candidate-content .control-link {
  color: white;
}
</style>
<style>
.control_page.embedded-region-page {
  height: calc(100% - 60px);
  overflow: hidden;
}
</style>
